class App {

	static start() {
		return new App();
	}

	constructor() {
		Promise
			.all([
				App.domReady(),
			])
			.then(this.init.bind(this));
	}

	static domReady() {
		return new Promise(resolve => {
			document.addEventListener('DOMContentLoaded', resolve);
		});
	}


	/**
	 * First time the website is loaded.
	 */
	init() {
		// console.info('App:init');

		// Prevent the scroll, always.
		history.scrollRestoration = 'manual';

		App.initSwup();
		App.setCssVars();

		// Global vars
		App.setTopBar(document);
		App.setPanel(document);
		App.setMainDOM(document);

		// Events
		App.topBarNavEvents();
		App.panelCloseBtn();
		App.topBarSticky();
		App.topBarSearch();
		App.topBarShare();
		App.topBarMobile();
		App.topBarContactLink();
		App.topBarProjectScrollTo();
		App.initLang();
		App.initSearch();

		App.pageIn(document);

		document.documentElement.classList.add('ready');
	}


	/**
	 * The new page that we navigate to.
	 */
	static pageIn(documentDOM) {
		// console.info('App:pageIn');

		// Analytics, send pageview
		gtag('config', 'UA-98763629-1', {
			'page_path': window.location.pathname
		});

		if (this.scrollBehavior == 'keep' && typeof this.scrollValues[window.location.href] !== 'undefined') {
			gsap.to(window, { duration: 0.2, scrollTo: this.scrollValues[window.location.href] });
		} else {
			gsap.to(window, { duration: 0.2, scrollTo: 0 });
		}

		App.productsIn(documentDOM);
		App.topBarShareRefresh(documentDOM);
		App.topBarLinkActivateRefresh(documentDOM);
		App.topBarNavShown(documentDOM);
		App.updateLang(documentDOM);
	}


	/**
	 * The page will be replaced.
	 */
	static pageOut() {
		// console.info('App:pageOut');
	}


	/**
	 * Products in.
	 * 1- Image loaded sur chaque produit, pour afficher l'image
	 *    du produit seulement quand l'image est telecharger.
	 * 2- Event pour l'affichage du panel de projets.
	 */
	static productsIn(documentDOM) {
		// 1-
		App.productsAnimateAppear(documentDOM);

		// 2-
		App.productsLinkedProjects(documentDOM);
	}


	/**
	 * PANEL
	 * Produits qui creent une ouverture du panel.
	 * 2 options : materiaux ou caracteristique :
	 * - jsLinkedProjects__caracteristique
	 * - jsLinkedProjects__materiau
	 */
	static productsLinkedProjects(documentDOM) {
		const
			caracteristiquesDOM = documentDOM.querySelectorAll(".jsLinkedProjects__caracteristique"),
			materiauxDOM = documentDOM.querySelectorAll(".jsLinkedProjects__materiau");

		App.productsLinkedProjectsType(caracteristiquesDOM, "caracteristique");
		App.productsLinkedProjectsType(materiauxDOM, "materiau");
	}


	/**
	 * PANEL / Click produit.
	 * Click sur un produit ouvre le panneau de projets.
	 */
	static productsLinkedProjectsType(productsDOM, type) {
		productsDOM.forEach(productDOM => {
			productDOM.addEventListener('click', (evt) => {
				evt.preventDefault();

				// ID
				const productID = productDOM.dataset.productId;

				if (typeof productID !== "undefined") {
					App.productsLinkedProjectsOpenPanel(productID, type);
				}
			});
		});
	}


	/**
	 * PANEL / Ajax call
	 * Ouvrir le panneau.
	 * Remplir le panneau des projets.
	 */
	static productsLinkedProjectsOpenPanel(id, type) {
		// Projects panel
		const
			panelDOM = this.panel,
			panel__ctnDOM = this.panel__in;

		// Init height (for first show)
		const panelHeight = panel__ctnDOM.offsetHeight;
		panel__ctnDOM.style.height = panelHeight + "px";

		// Hide the content of the panel
		panelDOM.classList.remove("show");
		panelDOM.classList.add("open");

		// Get panel data
		// AJAX data
		var dataAjax = {
			'action': 'panellinkedprojects',
			'productID': id,
			'productType': type
		};

		jQuery.ajax({
			url: objLoadMore.ajaxurl,
			type: 'POST',
			data: dataAjax,
			dataType: "json",

			success: function (data) {
				if (data) {
					// console.log(data.debug);

					// Add data
					App.panelSetContent(data.title, data.projects);

					// Creer un panneau identique avec le meme contenu 
					// dans le but de calculer la hauteur.
					let clonedPanel__ctnDOM = panel__ctnDOM.cloneNode(true);
					clonedPanel__ctnDOM.classList.add("panelProjects--clone");
					clonedPanel__ctnDOM.style.height = 'auto';
					document.body.appendChild(clonedPanel__ctnDOM);

					const panelHeight = clonedPanel__ctnDOM.offsetHeight;
					panel__ctnDOM.style.height = panelHeight + "px";

					clonedPanel__ctnDOM.parentNode.removeChild(clonedPanel__ctnDOM);

					// Show the panel with the data
					panelDOM.classList.add("show");

				}
			},

			error: function (jqXHR, textStatus, errorThrown) {
				// console.log(jqXHR);
				// console.log(textStatus);
				// console.log(errorThrown);
			}
		});
	}


	/**
	 * PANEL / Set content
	 * Set le contenu HTML dans le panel.
	 */
	static panelSetContent(title, projects) {
		const
			panelDOM = this.panel,
			titleDOM = panelDOM.querySelector(".jsPanel__title"),
			projectsDOM = panelDOM.querySelector(".jsPanel__projects");

		titleDOM.textContent = title;
		projectsDOM.innerHTML = projects;
	}



	/**
	 * SWUP JS
	 * https://github.com/swup/swup
	 * https://swup.js.org/getting-started
	 *
	 * Events :
	 * https://swup.js.org/events
	 */
	static initSwup() {

		// INIT ................................................................
		const swup = new Swup({
			animateHistoryBrowsing: true,
			plugins: [
				new SwupPreloadPlugin(),
				// new SwupDebugPlugin()
			]
		});

		// Make it a global var
		App.setSwup(swup);


		// OUT start ...........................................................
		// triggers when animation OUT starts (class is-animating is added to html tag)
		swup.on('animationOutStart', () => {
			// Ferme les panels mobile qui pourraient etre ouverts par inadvertance
			this.topBar.classList.remove("onNav");
			this.topBar.classList.remove("onSearch");

			// Close projects panel
			App.panelClose();

			// Close le share zone
			App.closeShare();

			// Dans ce cas-ci, un seul container
			// (Swup permet de modifier plusieurs containers...)
			swup.options.containers.forEach((selector) => {
				const containerDOM = document.querySelector(selector);

				// Images et video qui slideUp
				containerDOM.classList.add("animateOut");

				// Set the old height on the page.
				const containerHeight = containerDOM.offsetHeight;
				App.getMainDOM().style.height = containerHeight + "px";
			});
		});


		// OUT before page change ..............................................
		// triggers right before the content of page is replaced
		swup.on('willReplaceContent', function () {
			App.pageOut();
		});


		// IN after page change ................................................
		// triggers right after the content of page is replaced
		swup.on('contentReplaced', function () {
			swup.options.containers.forEach((selector) => {
				const containerDOM = document.querySelector(selector);

				// Video qui slideDown
				containerDOM.classList.add("willAnimate");

				// Set the new height on the page.
				const containerHeight = containerDOM.offsetHeight;
				App.getMainDOM().style.height = containerHeight + "px";

				// Page in
				App.pageIn(containerDOM);
			});
		});


		// IN done .............................................................
		// triggers when transition of all animated elements is done (after content is replaced)
		swup.on('animationInDone', function () {
			App.getMainDOM().style.height = 'auto';

			swup.options.containers.forEach((selector) => {
				const containerDOM = document.querySelector(selector);

				// Start animation : video qui slideDown
				containerDOM.classList.remove("willAnimate");
			});
		});


		// SAME PAGE ...........................................................
		// triggers when link leading to the same page is clicked
		swup.on('samePage', function () {
			// Reload la meme page.
			// Sinon, Swup ne reload pas.

			// Seulement si le lien clicked est vraiment un reload de la page...
			// Donc, on elimine les href="#"
			const href = event.delegateTarget.getAttribute("href");
			if (href == "#") { return; }

			const
				swupPage = swup.cache.getCurrentPage(),
				swupPageUrl = swupPage.url;

			// Remove this page from cache, so a BRAND NEW one will be generated!
			swup.cache.remove(swupPageUrl);

			swup.loadPage({
				url: swupPageUrl
			});
		});


		// SCROLL BEHAVIOR .....................................................
		// Click link = scroll to top
		// Back / next buttons = scroll where the user was
		this.scrollValues = {};
		this.currentPage = window.location.href;

		// triggers when link is clicked
		swup.on('clickLink', (event) => {
			this.scrollBehavior = 'top';
		});

		// triggers on popstate events (back/forward button)
		swup.on('popState', (event) => {
			this.scrollBehavior = 'keep';
		});

		// triggers when animation OUT starts (class is-animating is added to html tag)
		swup.on('animationOutStart', (event) => {
			this.scrollValues[this.currentPage] = window.scrollY;
		});

		// triggers right after the content of page is replaced
		swup.on('contentReplaced', (event) => {
			this.currentPage = window.location.href;
		});
	}


	/**
	 * CSS VARS
	 * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
	 * 
	 * Hauteur reelle du viewport.
	 * Avec ces variables, nous pouvons ajuster plus precisement
	 * la hauteur d'une section FULL HEIGHT sur mobile. C'est difficile
	 * de le faire en CSS, c'est pourquoi on cree une var en JS.
	 * 
	 * --vh :
	 * 		Update en temps reel.
	 * 		Pratique pour panel full height qui peut changer de hauteur
	 * 		car il n'influence pas les autres elements de la page
	 * 		(puisqu'il est position absolute ou fixed).
	 */
	static setCssVars() {
		App.cssVarsRefresh();

		window.addEventListener('resize', _.debounce(App.cssVarsRefresh.bind(App), 250));
	}

	static cssVarsRefresh() {
		document.documentElement.style.setProperty('--vh', App.getVH() + 'px');
	}

	static getVW() {
		return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	}

	static getVH() {
		return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	}


	/**
	 * TOPBAR
	 * Click events on the nav links.
	 */
	static topBarNavEvents() {
		const linksDOM = this.topBar__linksToActivate;

		// CLICK on link:
		// 1- Remove active on other links
		// 2- Activate it
		linksDOM.forEach(linkDOM => {
			linkDOM.addEventListener('click', (evt) => {
				App.topBarLinkActivate(linkDOM);
			});
		});
	}


	/**
	 * PANEL
	 * Close BTN.
	 * Close OVERLAY.
	 */
	static panelCloseBtn() {
		const panelDOM = this.panel;

		// CLOSE BTN + OVERLAY
		// Click on the close icon (or the overlay) closes the panel.
		const closesDOM = panelDOM.querySelectorAll(".jsPanel__close");

		closesDOM.forEach(closeDOM => {
			closeDOM.addEventListener("click", (evt) => {
				App.panelClose();
			});
		});
	}


	/**
	 * PANEL / Close action
	 * Close the panel :
	 * 1- Remove the classes.
	 * 2- Remove content AFTER the animation finishes.
	 */
	static panelClose() {
		const
			panelDOM = this.panel,
			panel__ctnDOM = this.panel__in;

		if (panelDOM.classList.contains("open")) {
			// 1-
			panelDOM.classList.remove("show");
			panelDOM.classList.remove("open");

			// 2-
			var transitionEvent = App.whichTransitionEvent();
			panelDOM.addEventListener(transitionEvent, function (evt) {
				App.panelSetContent('', '');
				panel__ctnDOM.style.height = "auto";

			}, { once: true });
		}
	}


	/**
	 * Transition END event
	 * Function from David Walsh: http://davidwalsh.name/css-animation-callback
	 */
	static whichTransitionEvent() {
		var t,
			el = document.createElement("fakeelement");

		var transitions = {
			"transition": "transitionend",
			"OTransition": "oTransitionEnd",
			"MozTransition": "transitionend",
			"WebkitTransition": "webkitTransitionEnd"
		}

		for (t in transitions) {
			if (el.style[t] !== undefined) {
				return transitions[t];
			}
		}
	}


	/**
	 * TOPBAR
	 * Set the link "active".
	 */
	static topBarLinkActivate(linkDOM) {
		const linksDOM = this.topBar__linksToActivate;

		// 1-
		linksDOM.forEach(linkDOM => {
			linkDOM.classList.remove('active');
		});

		// 2-
		if (typeof linkDOM !== "undefined") {
			linkDOM.classList.add('active');
		}
	}


	/**
	 * TOPBAR
	 * Each time the page change, change the "active" link.
	 */
	static topBarLinkActivateRefresh(documentDOM) {
		// Trouver la section de la nouvelle page afficher.
		const
			currentSectionDOM = documentDOM.querySelector("[data-current-section]"),
			currentSection = currentSectionDOM.dataset.currentSection,
			linkClass = 'currentSection__' + currentSection;

		// Get l'item de menu associer a cette section
		const navLIsDOM = this.topBar__navDesktop.querySelectorAll('li');
		let linkDOM;

		navLIsDOM.forEach(navLIDOM => {
			if (navLIDOM.classList.contains(linkClass)) {
				// Found
				linkDOM = navLIDOM.querySelector('a');
			}
		});

		// Active link
		this.topBarLinkActivate(linkDOM);
	}


	/**
	 * TOPBAR
	 * Each time the page change, check if the right nav is shown
	 */
	static topBarNavShown(documentDOM) {
		// Trouver la nav a afficher de la nouvelle page afficher.
		const
			navsDOM = this.topBar.querySelectorAll("[data-nav]"),
			navToShowDOM = documentDOM.querySelector("[data-current-nav]");

		let
			navToShow = navToShowDOM.dataset.currentNav;

		// Default value
		if (navToShow == '') {
			navToShow = 'main';
		}

		// Find the right nav and active it
		navsDOM.forEach(navDOM => {
			navDOM.classList.remove("on");

			if (navDOM.dataset.nav == navToShow) {
				navDOM.classList.add("on");
			}
		});
	}


	/**
	 * TOPBAR
	 * Sticky when the user scrolls up.
	 */
	static topBarSticky() {
		const
			topBar = this.topBar,
			topBar__ctn = this.topBar__ctn,

			// C'est triste que les valeurs sont hardcoded, mais ca evite de
			// tout recalculer au resize, donc on laisse ca comme ca.
			topBarHeight = "16em",
			topBarScrolledHeight = "12em";

		let
			scene,
			controller,
			enquire_query = 'screen and (min-width: 768px)',
			enquire_handler = {

				// ---------------------------------------------------------
				// MEDIA QUERY MATCH
				// Triggered when a media query matches.
				// ---------------------------------------------------------
				match: function () {
					controller = new ScrollMagic.Controller();
					scene = new ScrollMagic.Scene();

					let tween = gsap.fromTo(topBar__ctn, 1,
						{ height: topBarHeight, },
						{ height: topBarScrolledHeight });

					scene
						.triggerElement(topBar)
						.triggerHook(0)
						.duration(300)
						.setTween(tween)
						// .addIndicators()
						.addTo(controller);
				},


				// ---------------------------------------------------------
				// MEDIA QUERY UNMATCH
				// Triggered when the media query transitions
				// from a matched state to an unmatched state.
				// ---------------------------------------------------------
				unmatch: function () {
					scene.removeTween(true);
					gsap.set(topBar__ctn, { clearProps: 'all' });
					controller.destroy(true);
					controller.update(true);
				}
			}

		enquire.register(enquire_query, enquire_handler);


		// "scrolled" class : for desktop AND mobile
		const
			controllerScrolled = new ScrollMagic.Controller(),
			sceneScrolled = new ScrollMagic.Scene();

		sceneScrolled
			.duration(0)
			.offset(100)
			.setClassToggle(topBar, 'scrolled')
			// .addIndicators() // add indicators (requires plugin)
			.addTo(controllerScrolled);
	}


	/**
	 * TOPBAR
	 * Search box opens and close event.
	 */
	static topBarSearch() {
		const
			tBSearch = this.topBar.querySelector(".jsTBSearch"),
			tBSearch__open = tBSearch.querySelector(".jsTBSearch__open"),
			tBSearch__close = tBSearch.querySelector(".jsTBSearch__close"),
			tBSearch__input = tBSearch.querySelector(".jsTBSearch__input");

		// OPEN
		tBSearch__open.addEventListener("click", (evt) => {
			evt.preventDefault();
			tBSearch.classList.add("on");

			// Petit timeout sinon le focus ne se fait pas.
			setTimeout(function () {
				tBSearch__input.focus();
			}, 300);
		});

		// CLOSE
		tBSearch__close.addEventListener("click", (evt) => {
			evt.preventDefault();
			tBSearch.classList.remove("on");
		});
	}


	/**
	 * TOPBAR
	 * Share to social medias
	 */
	static topBarShare() {
		this.shareDOMs = this.topBar.querySelectorAll(".jsTopBarShare");

		const shareAPISupported = ('share' in navigator);
		// const shareAPISupported = false;

		this.shareDOMs.forEach(shareDOM => {
			const trigger = shareDOM.querySelector(".jsTopBarShare__trigger");


			// CLICK = Share
			// Web Share API. HTTPS seulement!
			// Fallback : Show list of medias
			trigger.addEventListener("click", function (evt) {
				evt.preventDefault();

				const
					swupPage = App.getSwup().cache.getCurrentPage(),
					shareTitle = swupPage.title,
					shareUrl = window.location.href;

				if (shareAPISupported) {
					const shareOpts = {
						title: shareTitle,
						url: shareUrl,
					};

					navigator.share(shareOpts);

				} else {
					// Share URLs to medias
					// https://css-tricks.com/simple-social-sharing-links/

					// Facebook
					const
						facebookDOM = shareDOM.querySelector(".jsTopBarShare__facebook"),
						facebookUrl = "https://www.facebook.com/sharer.php?u=" + shareUrl;

					facebookDOM.href = facebookUrl;

					// LinkedIn
					const
						linkedInDOM = shareDOM.querySelector(".jsTopBarShare__linkedIn"),
						linkedInUrl = "https://www.linkedin.com/shareArticle?mini=true&url=" + shareUrl;

					linkedInDOM.href = linkedInUrl;

					// Open this share zone
					shareDOM.classList.add("open");

					// On scroll, close this zone
					window.addEventListener('scroll', App.closeShareOnScroll);
				}
			});
		});

	}

	/**
	 * Closes the share zone on scroll.
	 * Scroll event execute just once.
	 */
	static closeShareOnScroll() {
		App.closeShare();
		window.removeEventListener('scroll', App.closeShareOnScroll);
	}

	/**
	 * Closes the share zone.
	 */
	static closeShare() {
		this.shareDOMs.forEach(shareDOM => {
			shareDOM.classList.remove("open");
		});
	}

	/**
	 * Share shown on specific pages only.
	 */
	static topBarShareRefresh(documentDOM) {
		let canShare = false;
		const canShareDOM = documentDOM.querySelector("[data-can-share]");

		if (canShareDOM) {
			canShare = canShareDOM.dataset.canShare || false;
		}

		// Show / hide
		if (canShare || canShare == '1') {
			this.shareDOMs.forEach(shareDOM => {
				shareDOM.classList.add("on");
			});
		} else {
			this.shareDOMs.forEach(shareDOM => {
				shareDOM.classList.remove("on");
			});
		}
	}


	/**
	 * TOPBAR
	 * Mobile events
	 */
	static topBarMobile() {
		const topBar = this.topBar;


		// HAMBURGER ICON ......................................................
		// OPEN nav panel
		// CLOSE all panels
		const btnHamburger = topBar.querySelector(".jsTopBar__hamburgerBtn");

		btnHamburger.addEventListener("click", (evt) => {
			evt.preventDefault();

			let hasClosed = false;

			if (topBar.classList.contains("onNav")) {
				topBar.classList.remove("onNav");
				hasClosed = true;
			}

			if (topBar.classList.contains("onSearch")) {
				topBar.classList.remove("onSearch");
				hasClosed = true;
			}

			if (!hasClosed) {
				topBar.classList.add("onNav");
			}
		});


		// NAV LINKS ...........................................................
		// When clicked, close the nav panel
		const topBar__navLinks = this.topBar__navMobile.querySelectorAll("a");

		topBar__navLinks.forEach(navLinkDOM => {
			navLinkDOM.addEventListener("click", (evt) => {
				topBar.classList.remove("onNav");
			});
		});


		// OPEN SEARCH .........................................................
		// Btn to open and close the search panel
		const toggleSearchBtnsDOM = topBar.querySelectorAll(".jsTopBar__openSearch");

		toggleSearchBtnsDOM.forEach(toggleBtnDOM => {
			toggleBtnDOM.addEventListener("click", (evt) => {
				evt.preventDefault();

				if (!topBar.classList.contains("onSearch")) {
					topBar.classList.add("onSearch");
				} else {
					topBar.classList.remove("onSearch");
				}
			});
		});
	}


	/**
	 * TOPBAR
	 * Contact is an internal link to the bottom of the page.
	 */
	static topBarContactLink() {
		const topBar__ctn = this.topBar__ctn;

		// Click on contact link scroll to bottom
		const contactLinksDOM = topBar__ctn.querySelectorAll(".jsTopBar__contactLink");

		contactLinksDOM.forEach(linkDOM => {
			linkDOM.addEventListener("click", (evt) => {
				evt.preventDefault();
				const scrollToContactDOM = document.querySelector("#footer-contact");

				// Faire fitter parfaitement :
				// on a besoin de la hauteur de la topbar.
				const scrollOffset = topBar__ctn.offsetHeight;

				jQuery.scrollTo(scrollToContactDOM, {
					offset: -scrollOffset,
					duration: 500
				});
			});

		});
	}


	/**
	 * TOPBAR
	 * Project internal links.
	 */
	static topBarProjectScrollTo() {
		const topBar__ctn = this.topBar__ctn;

		// Click link scrolls to section
		const scrollLinksDOM = topBar__ctn.querySelectorAll(".jsProjectScroll a");

		scrollLinksDOM.forEach(linkDOM => {
			linkDOM.addEventListener("click", (evt) => {
				evt.preventDefault();

				// Get la section a scroller (id dans href du linkDOM)
				const hash = linkDOM.getAttribute("href");

				// Faire fitter parfaitement :
				// on a besoin de la hauteur de la topbar.
				const scrollOffset = topBar__ctn.offsetHeight;

				// Scroll to hash
				if (hash !== '') {
					jQuery.scrollTo(hash, {
						offset: -scrollOffset,
						duration: 500
					});
				}
			});

		});
	}


	/**
	 * LANGUAGE
	 * Language links.
	 * We have to update them on each page change.
	 */
	static initLang() {
		this.langLinksFR = document.querySelectorAll(".jsLang__fr");
		this.langLinksEN = document.querySelectorAll(".jsLang__en");
	}

	static updateLang(documentDOM) {
		// Get les nouveaux URLs de lang
		const
			urlFrDOM = documentDOM.querySelector("[data-url-fr]"),
			urlEnDOM = documentDOM.querySelector("[data-url-en]"),
			urlFr = urlFrDOM.dataset.urlFr,
			urlEn = urlEnDOM.dataset.urlEn;
		
		// Update les liens
		this.langLinksFR.forEach(linkFR => {
			linkFR.href = urlFr;
		});

		this.langLinksEN.forEach(linkEN => {
			linkEN.href = urlEn;
		});
	}


	/**
	 * SEARCH
	 * Recherche fonctionnelle avec Swup.
	 */
	static initSearch() {
		this.searchForms = document.querySelectorAll(".jsSearch");

		this.searchForms.forEach(searchForm => {

			/**
			 * FORM SUBMIT
			 * Send the WordPress query URL with Swup
			 * URL semblable a : http://archvyz.com/?s=texterecherche
			 */
			searchForm.addEventListener("submit", function (evt) {
				evt.preventDefault();

				const
					formAction = searchForm.action,
					queryString = App.urlEncodeFormData(searchForm),
					resultsPageUrl = formAction + "?" + queryString;

				// Swup
				// loadPage : Navigates to a route with the animations
				// https://swup.js.org/api/methods
				App.getSwup().loadPage({
					url: resultsPageUrl
				});
			});
		});
	}

	static urlEncodeFormData(form) {
		var i, e, data = [];

		for (i = 0; i < form.elements.length; i++) {
			e = form.elements[i];

			if (e.type !== 'button' && e.type !== 'submit') {
				data.push(encodeURIComponent(e.name) + '=' + encodeURIComponent(e.value));
			}
		}

		return data.join('&');
	}


	/**
	* IMAGE LOAD EVENT
	* Image load sur chaque produit, pour afficher l'image
	* du produit seulement quand l'image est telecharger.
	*/
	static productsAnimateAppear(container) {
		let images = container.querySelectorAll(".iGridItem img");

		images.forEach(image => {
			if (image.complete) {
				App.productsAnimateAppearDo(image);

			} else {
				image.addEventListener('load', function () {
					App.productsAnimateAppearDo(image);
				});
			}
		});
	}

	static productsAnimateAppearDo(image) {
		let this_grid_item = App.parentUpTo(image, 'iGridItem');
		this_grid_item.classList.add('imgloaded');
	}


	/**
	* CLOSEST PARENT
	* Find first ancestor of el with class name,
	* or undefined if not found.
	*/
	static parentUpTo(el, className) {
		while (el && el.parentNode) {
			el = el.parentNode;

			if (el.classList.contains(className)) {
				return el;
			}
		}

		// Many DOM methods return null if they don't 
		// find the element they are searching for
		// It would be OK to omit the following and just
		// return undefined
		return null;
	}


	/**
	* GETTERS / SETTERS
	*/
	static setTopBar(documentDOM) {
		this.topBar = documentDOM.querySelector(".jsTopBar");
		this.topBar__ctn = this.topBar.querySelector(".jsTopBar__ctn");
		this.topBar__navMobile = this.topBar.querySelector('.jsTopBar__navMobile');
		this.topBar__navDesktop = this.topBar.querySelector('.jsTopBar__nav');
		this.topBar__linksToActivate = this.topBar__navDesktop.querySelector(".jsTopBar__navMain").querySelectorAll("a");
	}

	static setMainDOM(documentDOM) {
		this.mainDOM = documentDOM.querySelector("main");
	}

	static getMainDOM() {
		return this.mainDOM;
	}

	static setPanel(documentDOM) {
		this.panel = documentDOM.querySelector(".jsPanel");
		this.panel__in = this.panel.querySelector(".jsPanel__in");
	}

	static setSwup(swup) {
		this.swup = swup;
	}

	static getSwup() {
		return this.swup;
	}
}

App.start();
